(<template>
  <div id="footer">
    <el-menu id="footer">
      <div class="footer-flex-container">
        <div class="footer-flex-container">
          <translate>Powered by</translate>:&nbsp;
          <a href="http://www.codespring.ro/" target="_blank">
            <img id="footer-image" src="../assets/cs-logo.png">
          </a>&nbsp;&amp;
          <a href="https://u-hub.ro/" target="_blank">
            <img id="footer-image" src="../assets/u-hub-logo.png">
          </a>
        </div>
        <div class="footer-flex-container">
          <translate>Language</translate>:&nbsp;
          <el-select id="language-selector" name="language" v-model="lang" @change="languageChanged">
            <el-option v-for="(language, key) in $language.available" :key="key" :label="$gettext(language)" :value="key">
            </el-option>
          </el-select>
        </div>
        <div class="footer-flex-container">
          Copyright © 2017-2024.&nbsp;<span v-translate>All rights reserved.</span>
        </div>
      </div>
    </el-menu>
  </div>
</template>)

(<script>
export default {
  name: 'tourguide-footer',
  data () {
    return {
      lang: this.$localStorage.get('language')
    }
  },
  methods: {
    languageChanged (lang) {
      this.$localStorage.set('language', lang)
      location.reload()
    }
  }
}
</script>)

(<style>
#footer {
  width: 99.9%;
  position: absolute;
  bottom: 0;
}
#footer-image {
  height: 3em;
  padding: 0.1em;
}
.footer-flex-container {
  height: auto;
  width: auto;
  align-items: center;
  justify-content: center;
  text-align: center;
  display: -webkit-flex;
  display: flex;
  padding-left: 10px;
  padding-right: 10px;
}
#language-selector {
  width: 9em;
}
</style>)



// WEBPACK FOOTER //
// src/components/Tourguide-Footer.vue